export const openIntership = () => window.open('https://b1.ru/career/vacancies-future-today/', '_blank');
